/**
 * Purpose: Resolve the API origin for the current environment.
 */
export const getApiOrigin = (): string => {
  if (typeof window !== 'undefined' && import.meta.env.PROD) {
    return window.location.origin;
  }

  return import.meta.env.VITE_API_URL || 'http://localhost:8000';
};
